// Times are storytelling clock hours (can exceed 24 for the full loop). Positions keep text off children's faces.
export const SCENES = [
  {
    id: "morning", label: "Morning", start: 0, end: 5, hour: 6, phase: "morning", objX: 50,
    headline: "Every child deserves a place to learn, grow, and feel at home.",
    eyebrow: "Open 24 hours · Dallas",
    textPos: "bottom-left", card: null, cta: null,
  },
  {
    id: "welcome", label: "Welcome", start: 5, end: 10, hour: 7, phase: "morning", objX: 50,
    headline: "Welcome to RR&B 24 Hour Daycare",
    eyebrow: "Helping hundreds of Dallas parents",
    textPos: "bottom-left", card: null, cta: "eligibility",
  },
  {
    id: "transportation", label: "Bus", start: 10, end: 14, hour: 7.5, phase: "morning", objX: 74,
    headline: "Transportation available",
    eyebrow: "On the way",
    textPos: "bottom-left",
    card: { pos: "top-left", icon: "bus", title: "Transportation", body: "Transportation is available for enrolled families.", note: "Route details coming soon" },
    cta: "transportation",
  },
  {
    id: "drop-off", label: "Drop-off", start: 14, end: 20, hour: 8, phase: "morning", objX: 42,
    headline: "From drop-off, they're in caring hands.",
    eyebrow: "Good morning",
    textPos: "bottom-right", card: null, cta: "tour",
  },
  {
    id: "infant-care", label: "Infants", start: 20, end: 24, hour: 10, phase: "afternoon", objX: 52,
    headline: "Loving, attentive infant care",
    eyebrow: "Our littlest ones",
    textPos: "bottom-left",
    card: { pos: "top-right", icon: "baby", title: "Infant Care", body: "Gentle, attentive care for babies, from feeding time to nap time.", note: "Age ranges & ratios coming soon" },
    cta: "enroll",
  },
  {
    id: "learning", label: "Learning", start: 24, end: 34.5, hour: 13, phase: "afternoon", objX: 25,
    headline: "Play, learning, and guided interaction build creativity and confidence.",
    eyebrow: "Afternoon",
    textPos: "bottom-left",
    card: { pos: "bottom-right", icon: "blocks", title: "Learning", body: "Hands-on play and guided interaction every day.", note: "Curriculum details coming soon" },
    cta: "tour",
  },
  {
    id: "play", label: "Play", start: 34.5, end: 40, hour: 17, phase: "sunset", objX: 46,
    headline: "Time to move, explore, laugh, and have fun.",
    eyebrow: "Golden hour",
    textPos: "top-left",
    card: { pos: "bottom-left", icon: "sun", title: "Play", body: "Room to move, explore, and laugh together.", note: null },
    cta: null,
  },
  {
    id: "evening", label: "Evening", start: 40, end: 45, hour: 20, phase: "night", objX: 36,
    headline: "Daytime care or quiet evening hours…",
    eyebrow: "Evening",
    textPos: "bottom-right", card: null, cta: null,
  },
  {
    id: "overnight-care", label: "Overnight", start: 45, end: 50, hour: 23, phase: "night", objX: 42,
    headline: "…we're here around the clock.",
    eyebrow: "Overnight care",
    textPos: "top-left",
    card: { pos: "top-right", icon: "moon", title: "Overnight Care", body: "Calm, cozy overnight care for families who work late or overnight shifts.", note: "Overnight hours wording coming soon" },
    cta: "enroll",
  },
  {
    id: "free-child-care", label: "Enroll", start: 50, end: 54.4, hour: 30, phase: "dawn", objX: 64,
    headline: "Now enrolling. Apply today to see if you qualify for FREE child care.",
    eyebrow: "Now enrolling",
    textPos: "bottom-left", card: null, cta: "eligibility",
  },
];

export const VIDEO_DURATION = 54.4;

export const formatHour = (h) => {
  const hr = ((h % 24) + 24) % 24;
  const whole = Math.floor(hr);
  const mins = Math.round((hr - whole) * 60);
  const m = mins === 60 ? 0 : mins;
  const hh = (mins === 60 ? whole + 1 : whole) % 24;
  const suffix = hh < 12 ? "AM" : "PM";
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${suffix}`;
};
